import { render, staticRenderFns } from "./OccurrenceDropdown.vue?vue&type=template&id=c08ecdda&scoped=true&"
import script from "./OccurrenceDropdown.vue?vue&type=script&lang=js&"
export * from "./OccurrenceDropdown.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceDropdown.vue?vue&type=style&index=0&id=c08ecdda&prod&scoped=true&lang=css&"
import style1 from "./OccurrenceDropdown.vue?vue&type=style&index=1&id=c08ecdda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08ecdda",
  null
  
)

export default component.exports